import { useEffect, useState } from "react";
import cx from "classnames";
import { pagePathUrl } from "@/constants/url";
import Image from "next/image";
import { IChannelConfig, JumpChannelInfo } from "@/api/home";
import { CommonImage } from "@/components";
import { ImageType } from "@/components/CommonImage";

import Styles from "./index.module.scss";

const defaultDevice = require("@/assets/icon/default-device.png");
const defaultCover = require('@/assets/icon/circle-default-cover.jpg');

interface ICircleHeader {
  name: string;
  config: IChannelConfig;
  cover: string;
  noSubChannelInfo?: boolean;
  parentLabel?: string;
}

const CircleHeader = ({
  name,
  config,
  cover,
  noSubChannelInfo,
  parentLabel,
}: ICircleHeader) => {
  const { jump_channel_infos: info, pc_background_image: deviceImage } = config;

  const handleError = (e: any) => {
    e.target.src = defaultDevice?.default?.src;
    e.target.srcset = "";
  };

  return (
    <div className={Styles.content}>
      <div className={Styles.bg}>
        <CommonImage
          alt="devices background"
          layout="fill"
          cutMode="fill"
          src={deviceImage || defaultCover}
        />
      </div>
      <div className={Styles.series}>
        <div className={Styles.cover}>
          <CommonImage
            alt={name}
            layout="fill"
            cutMode="fill"
            type={ImageType.avatar}
            src={cover}
          />
        </div>
        <div className={Styles.info}>
          <div className={Styles.title}>
            {name}
            {parentLabel && <span>{parentLabel}</span>}
          </div>
          <div className={Styles.list}>
            {info?.map((item, index) => (
              <div
                className={Styles.item}
                key={item.slug}
                onClick={() => {
                  if (item.slug) {
                    window.open(`${pagePathUrl.device}/${item.slug}`);
                  }
                }}
              >
                <div className={Styles.listCover}>
                  <CommonImage
                    alt={item.name}
                    layout="fill"
                    cutMode="fill"
                    type={ImageType.device}
                    src={item.avatar_image}
                  />
                </div>

                <div className={Styles.name}>{item.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CircleHeader;
